import { matchPath } from 'react-router-dom';

// ----------------------------------------------------------------------

export { NavSection } from './components';

export function isExternalLink(path: string): boolean {
  return path.includes('http');
}

export function getActive(
  path: string,
  pathname: string,
  matchEnd?: boolean
): boolean {
  return path ? !!matchPath({ path, end: !!matchEnd }, pathname) : false;
}
